<template lang="pug">
  v-layout(row wrap class="mediumSmall")
    v-flex(xs12)
      .box-global-info
        h2
          | Datos de mi seguro
        ul
          ol
            p
              img(:src="icons.numeroPoliza" style="width:15px;margin-right:11px;margin-left:2px;" alt="numero-poliza")
              | N° de póliza
            p.omnesMedium.poliza-download
              | {{ guaranteed.numeroPoliza }}
              img(v-if="guaranteed.codigoProceso && (guaranteed.codigoProceso || []).length > 0" :src="icons.download" @click="getPDFElectronicPolicy($event)" alt="download")
          ol
            p
              img(:src="icons.calendar" alt="calendar")
              | Vigencia
            p.omnesMedium {{ guaranteed.fechaVigencia }} - {{ guaranteed.fechaFinVigencia }}
          ol
            p
              img(:src="icons.sumaAsegurada" alt="shield")
              | Suma Asegurada
              img(:src="icons.question" width="20px" @click="showTooltipModal('sumaAsegurada')" alt="question" class="question-mark-icon")
            p.omnesMedium {{ currency }}  {{ (Math.round(guaranteed.montoCoberturaPrincipal * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
          ol
            p
              img(:src="icons.montoPago" alt="moneda")
              | Monto de pago
            p.omnesMedium {{ currency }} {{ (Math.round(guaranteed.primaProgramada * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
          ol
            p
              img(:src="icons.frecuenciaPago" alt="calendar")
              | Frecuencia de pago
            p.omnesMedium {{ guaranteed.frecuenciaPago }}
          ol(v-if="guaranteed.oriProducto != null && (!guaranteed.oriProducto.includes('VIDA CON DEVOLUCION') || !guaranteed.producto.includes('Cash'))")
            p
              img(:src="icons.pagadoHasta" alt="check")
              | Pagado hasta
            p.omnesMedium {{ guaranteed.pagadoHasta }}
          ol(v-else)
            p
              img(:src="icons.pagadoHasta" alt="check")
              | Último pago
            p.omnesMedium {{ guaranteed.pagadoHasta }}
    v-flex(xs12)
      .box-comprobante-electronico.box-requirements(v-if="requirementsVida.length > 0")
        h2
          | Mis solicitudes
        v-layout(row wrap v-for="(requirement, index) in requirementsVida" :key='index')
          v-flex(xs9 md9 lg9 style="align-self: center;")
            p
              | {{ requirement.name }}
          v-flex(xs3 md3 lg3 style="text-align: right;")
            v-btn.download-btn-files(type='button' @click="goToTransact(requirement.codeGTM)") Aplicar
    //- v-flex(xs12)
      .box-medio-pago
        h2 Medio de pago
        v-layout(row wrap)
          v-flex(xs8)
            p
              img(:src="icons.visa" width="30px" style="margin-right:8px" alt="visa")
              | XXXXXXXXXX24
          v-flex(xs1)
          v-flex(xs3)
            v-btn.download-btn-files EDITAR
    //- v-flex(xs12)
      .box-beneficiarios
        h2
          | Mis beneficiarios
          img(:src="icons.question" width="20px" @click="showTooltipModal('beneficiarios')" alt="question" class="question-mark-icon")
        v-layout(row wrap)
          v-flex(xs8 class="name-beneficiario")
            p Carlos Humberto Limaylla
          v-flex(xs1)
          v-flex(xs3 class="percent-beneficiario")
            p.omnesMedium 50 %
        v-layout(row wrap)
          v-flex(xs8 lg8 class="name-beneficiario")
            p Roberto Miguel Britto
          v-flex(xs1)
          v-flex(xs3 class="percent-beneficiario")
            p.omnesMedium 50 %
    v-flex(xs12)
      .box-agente
        h2(v-if="guaranteed.oriProducto != null && (!guaranteed.oriProducto.includes('VIDA CON DEVOLUCION') || !guaranteed.producto.includes('Cash'))") Mi agente
        h2(v-else) Contáctanos
        v-layout(row wrap)
          v-flex(v-if="guaranteed.oriProducto != null && (!guaranteed.oriProducto.includes('VIDA CON DEVOLUCION') || !guaranteed.producto.includes('Cash'))" md8 lg8)
            p(@click="sendMailTo(null)" style="cursor:pointer")
              img(:src="icons.mensajeAgente" alt="mensajeAgente")
              | {{ guaranteed.emailAgente }}
          v-flex(v-else md8 lg8)
            //- p(@click="sendMailTo('servicios@interseguro.com.pe')" style="cursor:pointer")
            p
              img(:src="icons.mensajeAgente" alt="mensajeAgente")
              a(:href="links.WhatsApp" target="_blank" style="text-decoration:none")
                b Canales Digitales
    v-flex(xs12)
      //- TEMP: VIDA CASH NO TIENE EECC
      .box-estado-cuenta(v-if="isAvailableForDownloadEECC")
        h2
          | Estado de cuenta
          img(:src="icons.question" width="20px" @click="showTooltipModal('estadoCuenta')" alt="question" class="question-mark-icon")
        v-layout(row wrap)
          v-flex(v-if="!newVersionEECC" xs12)
            p Fecha:
          v-flex(:class="newVersionEECC ? 'xs5' : 'xs3'")
            label {{ newVersionEECC ? 'Fecha:' : 'Desde' }}
            v-dialog(ref='dialogStartEECC' v-model='eecc.modalStart', :return-value.sync="eecc.startDate" persistent='' lazy='' full-width='' width='290px')
              v-text-field(slot='activator' hide-details v-model="eecc.textFieldStartDate" outline readonly='')
              v-date-picker(v-model="eecc.startDate" locale="es-005" :min="eecc.minDate" :max="eecc.maxDate" type='month' scrollable='')
                v-spacer
                v-btn(flat='' color='primary' @click="eecc.modalStart = false") Cancel
                v-btn(flat='' color='primary' @click="$refs.dialogStartEECC.save(eecc.startDate)") OK
          v-flex(v-if="!newVersionEECC" xs1 style="flex-basis: 3.333333%; flex-grow: 0; max-width: 3.333333%;")
          v-flex(v-if="!newVersionEECC" xs3)
            label Hasta
            v-dialog(ref='dialogEndEECC' v-model='eecc.modalEnd' :return-value.sync="eecc.endDate" persistent='' lazy='' full-width='' width='290px' disabled style="cursor:initial;pointer-events:none")
              v-text-field(slot='activator' hide-details v-model="eecc.textFieldEndDate" outline readonly='')
              v-date-picker(v-model="eecc.endDate" locale="es-005" :min="eecc.minDate" :max="eecc.maxDate" type='month' scrollable='')
                v-spacer
                v-btn(flat='' color='primary' @click="eecc.modalEnd = false") Cancel
                v-btn(flat='' color='primary' @click="$refs.dialogEndEECC.save(eecc.endDate)") OK
          v-flex(:class="newVersionEECC ? 'xs4' : 'xs2'" :style="newVersionEECC ? '' : 'flex-basis: 21%; flex-grow: 0; max-width: 21%;'")
          v-flex(xs3 style="align-self:flex-end")
            v-btn.download-btn-files(type='button' style="margin-bottom:2px" @click="downloadStatusAccount(guaranteed)") Descargar
    v-flex(xs12)
      .box-comprobante-electronico
        h2
          | Comprobante Electrónico
          img(:src="icons.question" width="20px" @click="showTooltipModal('comprobanteElectronico')" alt="question" class="question-mark-icon")
        v-layout(row wrap)
          v-flex(xs4 style="flex-basis: 42.666667%; flex-grow: 0; max-width: 42.666667%;")
            label Documento
            v-select.date-selector(v-model="selectedTypeDoc" hide-details outline :items="items" placeholder='Tipo de comprobante' append-icon="expand_more")
          v-flex(xs1 style="flex-basis: 3.333333%; flex-grow: 0; max-width: 3.333333%;")
          v-flex(xs3)
            label Desde
            v-dialog(ref='dialogStart' v-model='ce.modalStart', :return-value.sync="ce.startDate" persistent='' lazy='' full-width='' width='290px')
              v-text-field(slot='activator' hide-details v-model="ce.textFieldStartDate" outline readonly='')
              v-date-picker(v-model="ce.startDate" locale="es-005" :min="ce.minDate" :max="ce.endDate" type='month' scrollable='')
                v-spacer
                v-btn(flat='' color='primary' @click="ce.modalStart = false") Cancel
                v-btn(flat='' color='primary' @click="$refs.dialogStart.save(ce.startDate)") OK
          v-flex(xs1 style="flex-basis: 3.333333%; flex-grow: 0; max-width: 3.333333%;")
          v-flex(xs3)
            label Hasta
            v-dialog(ref='dialogEnd' v-model='ce.modalEnd' :return-value.sync="ce.endDate" persistent='' lazy='' full-width='' width='290px')
              v-text-field(slot='activator' hide-details v-model="ce.textFieldEndDate" outline readonly='')
              v-date-picker(v-model="ce.endDate" locale="es-005" :min="ce.minDate" :max="ce.maxDate" type='month' scrollable='')
                v-spacer
                v-btn(flat='' color='primary' @click="ce.modalEnd = false") Cancel
                v-btn(flat='' color='primary' @click="$refs.dialogEnd.save(ce.endDate)") OK
          v-flex(xs9)
          v-flex(xs3)
            v-btn.download-btn-files(style="margin-top: 2em;" type='button' :disabled="ce.textFieldStartDate === null || ce.textFieldEndDate === null || (selectedTypeDoc === null || selectedTypeDoc === '')" @click="showComprobantesElectronicos()") Aplicar
    //- LOADER PROCESS
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Descargando...
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- MODAL INFO BULLETS
    v-dialog(v-model="bulletsModal" persistent width="100%")
      v-card
        v-card-text
          p.omnesRegular(style="text-align: center; font-size: 16px; padding: 30px 30px 24px 30px;") {{ textModal }}
          v-layout
            v-flex(xs4)
            v-flex(xs4)
              v-btn.download-btn-files.omnesSemibold(@click="bulletsModal = false") ACEPTAR
            v-flex(xs4)
    //- MESSAGE COMPROBANTES ELECTRONICOS WHEN SELECT DATE
    v-dialog(v-model="messageLoader" persistent width="500")
      v-card
        v-card-text
          v-layout(wrap row)
            v-flex(md4 lg4)
            v-flex(md4 lg4 style='text-align: center;margin-top: 1em;margin-bottom: 1em')
              img(:src="icons.alerta" alt="alerta")
            v-flex(md4 lg4)
          v-layout(wrap row)
            v-flex(md12)
              p.omnesRegular.message-date-alert-ce-mobile
                | Solo podrás descargar los comprobantes desde
                br
                strong 01/2019&nbsp;
                | , si necesitas los comprobantes emitidos&nbsp;
                br
                | antes de esa fechas comunícate al&nbsp;
                br
                strong (01) 500 0000.
          v-layout(wrap row)
            v-flex(md4 lg4)
            v-flex(md4 lg4)
              v-btn.download-btn-files.btn-date-alert-ce-mobile.omnesMedium(@click="messageLoader = false") Entendido
            v-flex(md4 lg4)
    //- DIALOG COMPROBANTES ELECTRONICOS
    v-dialog(v-model="loaderCE" persistent width="500")
      v-card.card-comprobantes
        v-card-text
          img#close-btn-ce(:src="icons.close" alt="downloadCe" @click="loaderCE = false")
          h2.omnesMedium Descarga los documentos según las fechas elegidas
          v-layout(wrap row v-if="listComprobantesElectronicos.length > 0")
            v-flex(xs4 sm4 v-if="listComprobantesElectronicos.length === 1")
            v-flex.comprobantes(xs4 sm4 v-for="(comprobante, index) in listComprobantesElectronicos" :key="comprobante.numero")
              v-layout(row wrap)
                v-flex(xs9 sm9)
                  p {{ comprobante.fechaEmision }}
                v-flex(xs3 sm3 @click="downloadComprobanteElectronico(comprobante.tipoDocumento, comprobante.serie, comprobante.correlativo, comprobante.historico)" style="cursor:pointer;")
                  img(:src="icons.downloadCe" alt="downloadCe")
            v-flex(xs4 sm4 v-if="listComprobantesElectronicos.length === 1")
    //- MODAL DE ERROR - GENERICO PARA MENSAJES
    v-dialog(class="comprobantes-error", v-model="errorModalComprobantes", width="500")
      v-card.sign-in-modal
        figure.text-xs-center
          img(:src="icons.oops" alt="iconError")
        h2.text-blue.text-xs-center Estimado cliente
        p.mt-3.text-xs-center
          span.d-block.g-text-gray-700(style="font-size:16px") En estos momentos no hay comprobantes electrónicos disponibles. Estamos tratando de solucionarlo lo más pronto posible.
        button.transition-all-3.hover-scale(@click="errorModalComprobantes = false") Entendido
</template>

<script>
import electronicVouchers from './../../interfaces/electronicVouchers'
import whoNoAvaibalePoliza from './../../interfaces/whoNoAvaibalePoliza'
import moment from 'moment'
import transacts from './../../interfaces/transacts'
import { mapActions, mapGetters } from 'vuex'
import Links from '../../interfaces/links'
import Functionalities from '../../interfaces/functionalities'

export default {
  data () {
    return {
      links: Links,
      // TEMPORAL: Modal para mostrar inestabilidad en el API de Comprobantes
      errorModalComprobantes: false,
      title: '',
      currency: '',
      loaderCE: false,
      selectedTypeDoc: null,
      items: [],
      listComrpobantesElectronicosActuales: [],
      listComprobantesElectronicos: [],
      requirementsVida: [],
      color: '#1745A8',
      size: '10px',
      loader: false,
      bulletsModal: false,
      messageLoader: false,
      textModal: '',
      tooltips: {
        showSumaAsegurada: false,
        showBeneficiarios: false,
        showNumeroPoliza: false,
        showEstadoCuenta: false,
        showComprobanteElectronico: false
      },
      icons: {
        visa: require('./../../assets/cambio-cobro/icon-visa.svg'),
        calendar: require('./../../assets/iconsv5/icon-calendar.svg'),
        check: require('./../../assets/iconsv5/icon-check.svg'),
        moneda: require('./../../assets/iconsv5/icon-moneda.svg'),
        question: require('./../../assets/iconsv5/icon-question.svg'),
        download: require('./../../assets/iconsv5/icon-download.svg'),
        shield: require('./../../assets/iconsv5/icon-shield.svg'),
        numeroPoliza: require('./../../assets/iconsv5/icon-numero-placa.svg'),
        mensajeAgente: require('./../../assets/vida-icons/icon-correo.svg'),
        close: require('./../../assets/iconsv5/icon-close-ce.svg'),
        downloadCe: require('./../../assets/iconsv5/icon-download-ce.svg'),
        frecuenciaPago: require('./../../assets/iconsv5/icon-frecuencia-pago.svg'),
        montoPago: require('./../../assets/iconsv5/icon-monto-pago.svg'),
        sumaAsegurada: require('./../../assets/iconsv5/icon-suma-asegurada.svg'),
        pagadoHasta: require('./../../assets/iconsv5/icon-pagado-hasta.svg'),
        alerta: require('./../../assets/iconsv5/icon-alerta.svg')
      },
      amplitude: {
        events: {
          downloadDocuments: 'Descarga de Documentos'
        }
      },
      eecc: {
        maxDate: null,
        minDate: null,
        modalStart: false,
        modalEnd: false,
        startDate: null,
        endDate: null,
        textFieldStartDate: null,
        textFieldEndDate: null
      },
      ce: {
        maxDate: null,
        minDate: null,
        modalStart: false,
        modalEnd: false,
        startDate: null,
        endDate: null,
        textFieldStartDate: null,
        textFieldEndDate: null
      },
      isAvailableForDownloadEECC: true,
      isAvailableForDownloadPoliza: true,
      isLoadingEstadoCuenta: false,
      isLoadingComprobantes: false,
      monthLabels: ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGOST', 'SEPT', 'OCT', 'NOV', 'DIC'],
      newVersionEECC: false
    }
  },
  props: ['guaranteed'],
  watch: {
    'eecc.startDate': function () {
      this.eecc.textFieldStartDate = this.eecc.textFieldEndDate = moment(this.eecc.startDate).locale('es').format('MMM-YYYY').split('.').join('')
      switch ((this.guaranteed.frecuenciaPago || '').toUpperCase()) {
      case 'ANUAL':
        this.eecc.textFieldEndDate = moment(this.eecc.startDate).add(1, 'year').subtract(1, 'month').locale('es').format('MMM-YYYY').split('.').join('')
        break
      case 'SEMESTRAL':
        this.eecc.textFieldEndDate = moment(this.eecc.startDate).add(5, 'months').locale('es').format('MMM-YYYY').split('.').join('')
        break
      case 'TRIMESTRAL':
        this.eecc.textFieldEndDate = moment(this.eecc.startDate).add(2, 'months').locale('es').format('MMM-YYYY').split('.').join('')
        break
      default:
        break
      }
    },
    'ce.startDate': function (val) {
      let minDateAvailable = moment('2018-12-31')
      let startDateSelected = moment(val + '-01')
      if (startDateSelected.isAfter(minDateAvailable)) {
        this.ce.textFieldStartDate = moment(this.ce.startDate).locale('es').format('MMM-YYYY').split('.').join('')
      } else {
        this.ce.modalStart = false
        this.messageLoader = true
      }
    },
    'ce.endDate': function (val) {
      let minDateAvailable = moment('2018-12-31')
      let endDateSelected = moment(val + '-01')
      if (endDateSelected.isAfter(minDateAvailable)) {
        this.ce.textFieldEndDate = moment(this.ce.endDate).locale('es').format('MMM-YYYY').split('.').join('')
      } else {
        this.ce.modalEnd = false
        this.messageLoader = true
      }
    }
  },
  methods: {
    ...mapActions('requirements', ['checkIfPolicyHasPending']),
    ...mapActions('formalities', ['getBeneficiariosPoliza', 'getFrequency', 'getWildcardFees']),
    ...mapActions('user', ['getPDFPolizaVida', 'getPDFPolizaVidaV2', 'checkJWT', 'getPDFPolizaElectronica', 'getElectronicDocuments', 'downloadComprobante', 'downloadComprobanteLegacy', 'getComprobantes']),
    ...mapActions('event', ['eventLog']),
    downloadStatusAccount () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.EECC, self.functionsRules, self)) {
        return
      }
      this.loader = true
      let start = this.eecc.startDate.split('-')
      let end = this.eecc.startDate.split('-')
      let startDate = moment([start[0], start[1] - 1])
      let endDate = moment([end[0], end[1]])

      // Periodo de Estado de Cuenta en consulta
      startDate = moment(this.eecc.startDate).startOf('month')

      if (this.newVersionEECC) {
        endDate = moment(this.eecc.startDate).endOf('month')
      } else {
        switch (this.guaranteed.frecuenciaPago.toUpperCase()) {
        case 'ANUAL':
          endDate = moment(this.eecc.startDate).add(1, 'year').subtract(1, 'days')
          break
        case 'SEMESTRAL':
          endDate = moment(this.eecc.startDate).add(6, 'months').subtract(1, 'days')
          break
        case 'TRIMESTRAL':
          endDate = moment(this.eecc.startDate).add(3, 'months').subtract(1, 'days')
          break
        case 'MENSUAL':
          endDate = moment(this.eecc.startDate).endOf('month')
          break
        default:
          endDate = moment(this.eecc.endDate).endOf('month')
          break
        }
      }

      // EVENT TRACK - Universal Analytics
      // EVENT UPDATE - 029
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mi seguros - Estado de cuenta',
        label: 'Seleccionar botón - Descargar'
      })
      // EVENT TRACK - GA4
      // EVENT UPDATE -029
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mi seguros - Estado de cuenta',
        CTA: 'Seleccionar botón - Descargar'
      })
      if (startDate.isAfter(endDate)) {
        // this.isLoadingEstadoCuenta = false
        this.loader = false
        this.$swal({
          title: 'Atención',
          text: 'La fecha de inicio debe ser menor a la fecha de fin.',
          confirmButtonText: 'Salir'
        })
        return
      }
      // TRACK EVENT - AMPLITUDE
      var productoConsultado = ''
      if (this.guaranteed.oriProducto === null) {
        if (this.guaranteed.modalidad === null) {
          productoConsultado = this.guaranteed.producto
        } else {
          productoConsultado = this.guaranteed.modalidad
        }
      } else {
        productoConsultado = this.guaranteed.oriProducto
      }
      const callbackThen = () => {
        // this.isLoadingEstadoCuenta = false
        /*
        this.$gtm.trackEvent({
          event: 'Descarga EC',
          category: 'Zona Privada',
          action: 'Estado de Cuenta',
          label: 'Descarga del Estado de Cuenta'
        })
        */
        self.$amplitude.getInstance()
          .logEvent(
            self.amplitude.events.downloadDocuments,
            {
              'Tipo Documento': 'Estado de Cuenta',
              'Producto Consultado': productoConsultado,
              'Meses consultados': [start[1], end[1]]
            }
          )
        self.loader = false
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de Estado de Cuenta',
            metadata: {
              numeroPoliza: self.guaranteed.numeroPoliza,
              productoConsultado: self.guaranteed.ramo,
              subproductoConsultado: self.guaranteed.nombreProducto
            }
          })
        }, 3000)
      }
      const callbackCatch = (err) => {
        self.loader = false
        self.$swal({
          title: 'Estimado Cliente',
          text: 'Tenemos algunos inconvenientes. Por favor, inténtalo de nuevo en unos minutos.',
          confirmButtonText: 'Entendido'
        })
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de Estado de Cuenta',
            metadata: {
              error: err,
              numeroPoliza: self.guaranteed.numeroPoliza,
              productoConsultado: self.guaranteed.ramo,
              subproductoConsultado: self.guaranteed.nombreProducto
            }
          })
        }, 3000)
      }
      if (this.newVersionEECC) {
        const request = {'codigoProducto': self.guaranteed.codigoProducto, 'numeroPoliza': self.guaranteed.numeroPoliza, 'fechaInicio': startDate.format('YYYY-MM-DD 00:00:00'), 'fechaFin': endDate.format('YYYY-MM-DD 23:59:59')}
        self.getPDFPolizaVidaV2(request).then(callbackThen).catch(callbackCatch)
      } else {
        const request = {'codigoProducto': self.guaranteed.codigoProducto, 'numeroPoliza': self.guaranteed.numeroPoliza, 'fechaInicio': startDate.format('DD/MM/YYYY'), 'fechaFin': endDate.format('DD/MM/YYYY')}
        self.getPDFPolizaVida(request).then(callbackThen).catch(callbackCatch)
      }
    },
    showTooltipModal (obj) {
      switch (obj) {
      case 'poliza':
        this.bulletsModal = true
        this.textModal = 'Obtén las condiciones de tu póliza contratada cuando lo necesites.'
        break

      case 'sumaAsegurada':
        this.bulletsModal = true
        this.textModal = 'El monto indicado es la suma asegurada por fallecimiento.'
        break

      case 'coberturas':
        this.bulletsModal = true
        this.textModal = 'Detallamos las coberturas que les corresponde de tu póliza vehicular.'
        break

      case 'comprobanteElectronico':
        this.bulletsModal = true
        this.textModal = 'Podrás descargar tus comprobantes como boleta, factura, nota de crédito del periodo que elijas.'
        break

      case 'beneficiarios':
        this.bulletsModal = true
        this.textModal = 'Detallamos el nombre de tus beneficiarios así como el % que les corresponde de tu suma asegurada.'
        break

      case 'estadoCuenta':
        this.bulletsModal = true
        this.textModal = 'Encuentra el estado de póliza, monto de cobertura, pagos, fecha de pago.'
        break
      }
    },
    async getPDFElectronicPolicy (evt) {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.DESCARGA_POLIZA, self.functionsRules, self, self.guaranteed.producto)) {
        return
      }
      evt.preventDefault()
      this.loader = true
      // TRACK EVENT - GA
      /*
      this.$gtm.trackEvent({
        event: 'DPE',
        category: 'Zona Privada',
        action: 'PolizaElectronica',
        label: 'Descarga de Póliza Electrónica'
      })
      */
      // TRACK EVENT - AMPLITUDE
      var productoConsultado = ''
      if (this.guaranteed.oriProducto === null) {
        if (this.guaranteed.modalidad === null) {
          productoConsultado = this.guaranteed.producto
        } else {
          productoConsultado = this.guaranteed.modalidad
        }
      } else {
        productoConsultado = this.guaranteed.oriProducto
      }
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.downloadDocuments,
          {
            'Tipo Documento': 'Poliza VIDA-' + productoConsultado
            // 'Producto Consultado': productoConsultado
          }
        )
      await this.getPdfPoliza({numPoliza: this.guaranteed.numeroPoliza, makeDownload: true}, this.guaranteed.codigoProceso)
    },
    async getPdfPoliza (data, codigosProceso) {
      const self = this
      let downloaded = false
      for (let x = 0; x < codigosProceso.length && !downloaded; x++) {
        try {
          const res = await this.getPDFPolizaElectronica({...data, codProceso: codigosProceso[x]})
          if (res.status === 204) {
            this.loader = false
            if (x === codigosProceso.length - 1) {
              this.$swal({
                title: 'Comunicado',
                text: 'Lamentamos las molestias, esta póliza aún no está disponible en formato electrónico. Estamos trabajando para ofrecerla lo antes posible.',
                confirmButtonText: 'Entendido'
              })
            }
          } else {
            this.loader = false
            downloaded = true
          }
        } catch (error) {
          if (x === codigosProceso.length - 1) {
            this.loader = false
          }
        }

        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de póliza',
            metadata: {
              numeroPoliza: self.guaranteed.numeroPoliza,
              productoConsultado: self.guaranteed.ramo,
              subproductoConsultado: self.guaranteed.nombreProducto
            }
          })
        }, 3000)
        /* .then(res => {
            // HTTP RESPONSE: NO CONTENT
          })
          .catch(() => {
            if (x === codigosProceso.length - 1) {
              this.loader = false
            }
          })
        */
      }
    },
    sendMailTo (agent) {
      var mail = document.createElement('a')
      if (agent === null) {
        mail.href = 'mailto:' + this.guaranteed.emailAgente
      } else {
        mail.href = 'mailto:' + agent
      }
      mail.click()
    },
    showComprobantesElectronicos () {
      let self = this
      const nombreProducto = this.guaranteed.nombreProducto || this.guaranteed.producto
      if (!Functionalities.isAvailable(Functionalities.vida.COMPROBANTES, self.functionsRules, self, nombreProducto)) {
        return
      }
      if (this.listComrpobantesElectronicosActuales.length < 1) {
        this.errorModalComprobantes = true
      }
      // EVENT TRACK  Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mi seguros - Comprobante electrónico',
        label: 'Seleccionar botón - Aplicar'
      })
      // EVENT TRACK  GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mi seguros - Comprobante electrónico',
        CTA: 'Seleccionar botón - Aplicar'
      })
      if (self.ce.startDate !== null && self.ce.endDate !== null && self.selectedTypeDoc !== null) {
        this.loader = true
        // LIMPIANDO LOS COMPROBANTES
        this.listComprobantesElectronicos = []
        let startDate = moment(self.ce.startDate + '-01')
        let endDate = moment(self.ce.endDate + '-01').endOf('month')
        // COMPROBANTES ELECTRONICOS VERIFICAR QUE TIPOS TIENE (HISTORICOS O RECIENTES)
        if (self.selectedTypeDoc.includes('PP') || self.selectedTypeDoc.includes('PESC')) {
          let documents = self.listComrpobantesElectronicosHistoricos
          let selectedTypeDoc = self.selectedTypeDoc.split('.')[0]
          for (let index = 0; index < documents.length; index++) {
            let arrFechaEmisionPaper = documents[index].fechaEmision.split(' ')[0].split('/')
            let fechaEmisionPaper = arrFechaEmisionPaper[2] + '-' + arrFechaEmisionPaper[1] + '-' + arrFechaEmisionPaper[0]
            let fechaEmision = moment(fechaEmisionPaper)
            if (fechaEmision.isBetween(startDate, endDate) && (selectedTypeDoc === documents[index].tipoComprobante)) {
              let fechaEmisionFormat = moment(fechaEmisionPaper, 'YYYY-MM-DD').locale('es').format('MMM-YYYY').replace('.', '')
              fechaEmisionFormat = fechaEmisionFormat.charAt(0).toUpperCase() + fechaEmisionFormat.slice(1)
              let serie = ''
              switch (documents[index].tipoComprobante) {
              case 'FAC':
                serie = '01'
                break
              case 'B/V':
                serie = '03'
                break
              default:
                serie = '07'
                break
              }
              let hash = {
                fechaEmision: fechaEmisionFormat,
                tipoDocumento: documents[index].tipoComprobante,
                serie: serie,
                correlativo: documents[index].secuencial,
                historico: true
              }
              this.listComprobantesElectronicos.push(hash)
            }
          }
        }
        // CONDICIONAL PARA CUBRIR TODOS LOS COMPROBANTES
        if (self.selectedTypeDoc.includes('ESC') || self.selectedTypeDoc.includes('PESC')) {
          let selectedTypeDoc = ''
          if (self.selectedTypeDoc.includes('PESC')) {
            selectedTypeDoc = self.selectedTypeDoc.split('.')[1]
          } else {
            selectedTypeDoc = self.selectedTypeDoc.split('.')[0]
          }
          if (this.listComrpobantesElectronicosActuales.length > 0) {
            let documents = this.listComrpobantesElectronicosActuales
            // POBLANDO LOS COMPROBANTES
            for (let index = 0; index < documents.length; index++) {
              let fechaEmision = moment(documents[index].fechaEmision)
              if (fechaEmision.isBetween(startDate, endDate) && (selectedTypeDoc === documents[index].tipoComprobante)) {
                let fechaEmisionFormat = moment(documents[index].fechaEmision, 'YYYY-MM-DD').locale('es').format('MMM-YYYY').replace('.', '')
                fechaEmisionFormat = fechaEmisionFormat.charAt(0).toUpperCase() + fechaEmisionFormat.slice(1)
                let hash = {
                  fechaEmision: fechaEmisionFormat,
                  tipoDocumento: documents[index].tipoComprobante,
                  serie: documents[index].serie,
                  correlativo: documents[index].numero,
                  historico: false
                }
                this.listComprobantesElectronicos.push(hash)
              }
            }
            this.loader = false
            this.loaderCE = true
          } else {
            this.loader = false
          }
        }
        this.loader = false
        this.loaderCE = true
      } else {
        self.$swal({
          title: 'Estimado cliente',
          text: 'Debe completar la información para buscar sus comprobantes electrónicos.',
          confirmButtonText: 'Entendido'
        })
      }
    },
    downloadComprobanteElectronico (tipoComprobante, serie, numero, esHistorico) {
      const self = this
      const nombreProducto = this.guaranteed.nombreProducto || this.guaranteed.producto
      if (!Functionalities.isAvailable(Functionalities.vida.COMPROBANTES, self.functionsRules, self, nombreProducto)) {
        return
      }
      this.loader = true
      let hash = {
        tipoDocumento: tipoComprobante,
        serie: serie,
        correlativo: numero,
        producto: this.guaranteed.oriProducto || this.guaranteed.producto,
        grupoProducto: this.guaranteed.ramo.toUpperCase(),
        numeroPoliza: this.guaranteed.numeroPoliza
      }
      // TRACK EVENT - GA
      /*
      this.$gtm.trackEvent({
        event: 'Descargas Comprobantes Elec.',
        category: 'Zona Privada',
        action: 'ComprobantesElectronicos',
        label: 'Descarga de Comprobantes Electrónicos'
      })
      */
      // TRACK EVENT - AMPLITUDE
      var productoConsultado = ''
      if (this.guaranteed.oriProducto === null) {
        if (this.guaranteed.modalidad === null) {
          productoConsultado = this.guaranteed.producto
        } else {
          productoConsultado = this.guaranteed.modalidad
        }
      } else {
        productoConsultado = this.guaranteed.oriProducto
      }
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.downloadDocuments,
          {
            'Tipo Documento': 'Comprobantes Electrónicos',
            'Producto Consultado': productoConsultado,
            'Meses consultados': [this.ce.startDate.split('-')[1], this.ce.endDate.split('-')[1]]
          }
        )
      const callbackEventLog = (omitEvent) => {
        if (!omitEvent) {
          self.eventLog({
            categoria: 'Documentos',
            nombre: 'Descarga Comprobantes/Boletas',
            datos: hash
          })
        }
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de Comprobante',
            metadata: self.metadata
          })
        }, 3000)
      }
      if (esHistorico) {
        hash.Tipo = 'histórico'
        let xml = {
          tipoDoc: serie,
          folio: numero
        }
        this.downloadComprobanteLegacy(xml)
          .then(res => {
            self.loader = false
            hash.Estado = 'Exitoso'
            hash.respuesta = res.data
            hash.statusCode = res.status
            callbackEventLog()
          })
          .catch((err) => {
            hash.error = err.response.data
            hash.statusCode = err.response.status
            self.loader = false
            callbackEventLog()
          })
      } else {
        this.downloadComprobante(hash)
          .then((res) => {
            self.loader = false
            callbackEventLog(true)
          })
          .catch((err) => {
            self.loader = false
            if (err.data.codigoRespuesta === '99') {
              self.$swal({
                title: 'Estimado cliente',
                text: 'El Comprobante de Pago Electrónico ' + numero + ' , especificado no está registrado o no se encuentra en estado ACEPTADO.',
                confirmButtonText: 'Entendido'
              })
            } else {
              callbackEventLog(true)
            }
          })
      }
    },
    closeModalGuaranteed () {
      // HIDE SUB-NAV
      this.$root.$emit('hideGuaranteed', {})
    },
    verifDownload (producto) {
      const strUpper = producto.toUpperCase()
      const chars = {
        'Á': 'A',
        'É': 'E',
        'Í': 'I',
        'Ó': 'O',
        'Ú': 'U',
        'À': 'A',
        'È': 'E',
        'Ì': 'I',
        'Ò': 'O',
        'Ù': 'U',
        'Ñ': 'N'
      }
      const expr = /[áàéèíìóòúùñ]/ig

      let result = strUpper.replace(expr, function (e) {
        return chars[e]
      })

      const notDownload = [
        'FLEX',
        'INVERSION'
      ]

      for (let i = 0; i < notDownload.length; i++) {
        if (result.indexOf(notDownload[i]) > -1) {
          return false
        }
      }
      return true
    },
    goToTransact (transactCode) {
      // EVENT TRACK - Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mi seguros - Mis solicitudes',
        label: 'Seleccionar botón - Aplicar'
      })
      // EVENT TRACK - GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mi seguros - Mis solicitudes',
        CTA: 'Seleccionar botón - Aplicar'
      })
      if (!Functionalities.isAvailable(Functionalities.vida[transactCode], this.functionsRules, this)) {
        return
      }
      // SI es beneficiarios, ir a la pagina independiente
      var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
      for (var i = 0; i < allElements.length; i++) {
        allElements[i].classList.remove('active-menu')
      }
      var el = allElements[4] // MI PERFIL
      el.classList.add('active-menu')
      if (transactCode === 'VIMDB') {
        this.$router.push({ name: 'PerfilBeneficiarios',
          params: {
            policy: this.guaranteed.numeroPoliza,
            productName: this.guaranteed.producto,
            producto: this.guaranteed.ramo,
            subProducto: this.guaranteed.nombreProducto
          }
        })
      } else {
        this.$router.push({ name: 'Formalities', params: { seguroCodeGTM: transactCode, seguroPolicy: this.guaranteed.numeroPoliza } })
      }
    }
  },
  mounted () {
    let self = this
    const sustract = new Date().getDate()
    // new Version EECC for FLEX & VIDAINVERSION
    this.newVersionEECC = (['FLEX65', 'FLEX80', 'VIDAINVERSION'].includes(this.guaranteed.nombreProducto))
    // WARN: MONEDA de la póliza
    this.currency = this.guaranteed.primaProgramadaMoneda === 'Nuevo Sol' || this.guaranteed.primaProgramadaMoneda === 'NUEVO SOL' ? 'S/' : '$'

    // maxDate según frecuencia de pago
    if (this.newVersionEECC) {
      this.eecc.maxDate = moment().subtract(sustract >= 5 ? 1 : 2, 'months').format('YYYY-MM')
    } else {
      switch ((this.guaranteed.frecuenciaPago || '').toLowerCase()) {
      case 'anual':
        this.eecc.maxDate = moment().subtract(1, 'year').format('YYYY-MM')
        break
      case 'semestral':
        this.eecc.maxDate = moment().subtract(6, 'months').format('YYYY-MM')
        break
      case 'trimestral':
        this.eecc.maxDate = moment().subtract(3, 'months').format('YYYY-MM')
        break
      default:
        this.eecc.maxDate = moment().subtract(1, 'months').format('YYYY-MM')
        break
      }
    }
    this.ce.maxDate = moment().format('YYYY-MM')
    let minArrDate = this.guaranteed.fechaVigencia.split('/')
    this.eecc.minDate = this.ce.minDate = minArrDate[2] + '-' + minArrDate[1]
    // TMP: Verificar si tienen fecha de inicio/fin de vigencia
    this.guaranteed.asegurado = this.guaranteed.asegurado === null ? '-' : this.guaranteed.asegurado
    this.guaranteed.fechaIniVidaEstadoCta = this.guaranteed.fechaIniVidaEstadoCta === null ? new Date() : this.guaranteed.fechaIniVidaEstadoCta
    this.guaranteed.fechaFinVidaEstadoCta = this.guaranteed.fechaFinVidaEstadoCta === null ? new Date() : this.guaranteed.fechaFinVidaEstadoCta
    this.eecc.startDate = moment(this.guaranteed.fechaIniVidaEstadoCta, 'DD-MM-YYYY')
    this.eecc.endDate = moment(this.guaranteed.fechaFinVidaEstadoCta, 'DD-MM-YYYY').subtract(1, 'months').format('YYYY-MM')
    // TMP: Fechas para comprobante electronico
    this.ce.startDate = moment(new Date(), 'DD-MM-YYYY').subtract(1, 'months').format('YYYY-MM')
    this.ce.endDate = moment(new Date(), 'DD-MM-YYYY').format('YYYY-MM')

    // Condicionales de fecha para Estado de cuenta
    if (this.newVersionEECC) {
      this.eecc.startDate = moment(new Date(), 'DD-MM-YYYY').subtract(sustract >= 5 ? 1 : 2, 'months').format('YYYY-MM')
    } else {
      switch ((this.guaranteed.frecuenciaPago || '').toLowerCase()) {
      case 'anual':
        this.eecc.startDate = moment(this.guaranteed.fechaFinVidaEstadoCta, 'DD-MM-YYYY').subtract(1, 'months').subtract(1, 'year').format('YYYY-MM')
        break
      case 'pagounico':
      case 'primapagounico':
        this.eecc.startDate = moment(this.guaranteed.fechaFinVidaEstadoCta, 'DD-MM-YYYY').subtract(1, 'year').format('YYYY-MM')
        break
      case 'mensual':
        this.eecc.startDate = moment(new Date(), 'DD-MM-YYYY').subtract(1, 'months').format('YYYY-MM')
        break
      case 'trimestral':
        this.eecc.startDate = moment(this.guaranteed.fechaFinVidaEstadoCta, 'DD-MM-YYYY').subtract(3, 'months').format('YYYY-MM')
        break
      case 'semestral':
        this.eecc.startDate = moment(this.guaranteed.fechaFinVidaEstadoCta, 'DD-MM-YYYY').subtract(6, 'months').format('YYYY-MM')
        break
      default:
        this.eecc.startDate = moment(this.guaranteed.fechaIniVidaEstadoCta, 'DD-MM-YYYY').format('YYYY-MM')
        break
      }
    }

    // VERIFICA SI UN PRODUCTO VIDA ESTA DISPONIBLE PARA DESCARGAR POLIZA ELECTRONICA
    for (let j = 0; j < whoNoAvaibalePoliza.length; j++) {
      if (this.guaranteed.oriProducto != null && this.guaranteed.oriProducto.includes(whoNoAvaibalePoliza[j])) {
        this.isAvailableForDownloadPoliza = false
        break
      }
    }
    // VERIFICA SI UN PRODUCTO VIDA ESTA DISPONIBLE PARA DESCARGA SU EECC
    if (this.guaranteed.oriProducto != null && (this.guaranteed.oriProducto.includes('Cash') || this.guaranteed.producto.includes('Cash'))) {
      this.isAvailableForDownloadEECC = false
    }
    // HACER UN ARREGLO ORDENADO PARA LOS REQUERIMIENTOS VIDA
    let transactsVida = []
    if (this.guaranteed.producto === 'Vida Cash') {
      transactsVida = transacts.vida
    } else {
      transactsVida = transacts.vida.filter(transact => transact !== 'Anulación de póliza')
    }
    this.checkIfPolicyHasPending({ numeroPoliza: this.guaranteed.numeroPoliza })
      .then((res) => {
        let toRemove = []
        let array = []
        let requirements = res.data.data.filter((req) => req.transact !== 'Liberación de endoso')

        for (let index = 0; index < transactsVida.length; index++) {
          let codeGTM = ''
          switch (transactsVida[index]) {
          case 'Cuota comodín':
            codeGTM = transacts.codesGTM.CUOTA_COMODIN
            break
          case 'Liberación de endoso':
            codeGTM = transacts.codesGTM.LIBERACION_ENDOSO
            break
          case 'Endoso a entidad financiera':
            codeGTM = transacts.codesGTM.ENDOSOS_ENTIDAD_FINANCIERA
            break
          case 'Cambio Frecuencia de Pago':
            codeGTM = transacts.codesGTM.CAMBIO_FRECUENCIA_PAGO
            break
          case 'Modificación de Beneficiarios':
            codeGTM = transacts.codesGTM.MODIFIC_BENEFICI
            break
          default:
            codeGTM = transacts.codesGTM.ANULACION_POLIZA
            break
          }
          this.requirementsVida.push({ name: transactsVida[index], codeGTM: codeGTM })
        }
        for (let requirement of requirements) {
          if (toRemove.indexOf(requirement.transact) < 0) {
            toRemove.push(requirement.transact)
          }
        }
        for (let requirement of this.requirementsVida) {
          if (!toRemove.includes(requirement.name)) {
            array.push(requirement)
          }
        }
        this.requirementsVida = array

        toRemove = []
        for (let requirement of this.requirementsVida) {
          switch (requirement.codeGTM) {
          case transacts.codesGTM.CUOTA_COMODIN:
            if (!this.guaranteed.puedeCuotaComodin) {
              toRemove.push(requirement.codeGTM)
            }
            break
          case transacts.codesGTM.ENDOSOS_ENTIDAD_FINANCIERA:
            if (!this.guaranteed.puedeEndosar) {
              toRemove.push(requirement.codeGTM)
            }
            break
          case transacts.codesGTM.CAMBIO_FRECUENCIA_PAGO:
            if (!this.guaranteed.puedeCambiarFrecuencia) {
              toRemove.push(requirement.codeGTM)
            }
            break
          case transacts.codesGTM.LIBERACION_ENDOSO:
            if (!this.guaranteed.puedeLiberarEndoso) {
              toRemove.push(requirement.codeGTM)
            }
            break
          case transacts.codesGTM.MODIFIC_BENEFICI:
            if (!this.guaranteed.puedeCambiarBeneficiario) {
              toRemove.push(requirement.codeGTM)
            }
            break
          }
        }
        array = []
        for (let requirement of this.requirementsVida) {
          if (!toRemove.includes(requirement.codeGTM)) {
            array.push(requirement)
          }
        }
        this.requirementsVida = array
      })
      .catch((err) => { console.log('err: ', err) })
    // COMPROBANTES ELECTRONICOS VERIFICAR QUE TIPOS TIENE
    this.items = []
    let item = { numeroPoliza: Number(this.guaranteed.numeroPoliza).toString() }
    /*
    self.getElectronicDocuments(item)
      .then((res) => {
        if (res.data.documentosElectronicos.length > 0) {
          self.listComrpobantesElectronicosHistoricos = res.data.documentosElectronicos
          let arrVouchers = self.listComrpobantesElectronicosHistoricos.map(f => { return f.tipoComprobante })
          let arrTypeDocs = arrVouchers.filter(function (item, index) { return arrVouchers.indexOf(item) >= index })
          for (let index = 0; index < arrTypeDocs.length; index++) {
            switch (arrTypeDocs[index]) {
            case 'FAC':
              self.items.push({text: 'Factura', value: 'FAC.PP'})
              break
            case 'N/C':
              self.items.push({text: 'Nota crédito', value: 'N/C.PP'})
              break
            case 'B/V':
              self.items.push({text: 'Boleta de venta', value: 'B/V.PP'})
              break
            }
          }
        }
      })
    */
    const datosEventLog = {
      producto: self.guaranteed.nombreProducto,
      grupoProducto: self.guaranteed.ramo.toUpperCase(),
      numeroPoliza: self.guaranteed.numeroPoliza
    }

    const nombreProducto = self.guaranteed.nombreProducto || self.guaranteed.producto
    if (Functionalities.isAvailableSilent(Functionalities.vida.COMPROBANTES, self.functionsRules, nombreProducto)) {
      self.getComprobantes(item)
        .then((res) => {
          if ((res.data.codigoRespuesta === '01') && (res.data.documentos.length > 0)) {
            datosEventLog.documentos = res.data.documentos
            datosEventLog.Estado = 'Exitoso'
            self.listComrpobantesElectronicosActuales = res.data.documentos
            let documents = self.listComrpobantesElectronicosActuales
            let arrDocuments = []
            // SE OBTIENE LOS CODIGOS DE SUNAT DE CADA COMPROBANTE
            for (let index = 0; index < documents.length; index++) {
              arrDocuments.push(documents[index].tipoComprobante)
            }
            let arrDocsUniq = arrDocuments.filter(function (item, pos) {
              return arrDocuments.indexOf(item) === pos
            })
            // - this.items.push({ text: 'Tipo de comprobante', value: null })
            arrDocsUniq.forEach(el => {
              for (let j = 0; j < electronicVouchers.length; j++) {
                let noEncontroMatch = true
                // SE HACE MATCH
                if (electronicVouchers[j].codigoSunat === el) {
                  // DETECTAR SI YA ESTA REPETIDO DEL LEGACY
                  for (let x = 0; x < self.items.length; x++) {
                    if (self.items[x].text === electronicVouchers[j].descripcion) {
                      let newValue = self.items[x].value.split('.')
                      self.items[x].value = newValue[0] + '.' + electronicVouchers[j].codigoSunat + '.PESC'
                      noEncontroMatch = false
                      break
                    }
                  }
                  if (noEncontroMatch) {
                    self.items.push({
                      text: electronicVouchers[j].descripcion,
                      value: electronicVouchers[j].codigoSunat + '.ESC'
                    })
                    break
                  }
                }
              }
            })
            if (self.items.length === 1) {
              self.selectedTypeDoc = self.items[0].value
            }
          } else if ((res.data.codigoRespuesta === '01') && (res.data.documentos.length === 0)) {
            datosEventLog.error = res.data
            datosEventLog.statusCode = res.status
            datosEventLog.Estado = 'Vacío'
            this.$swal({
              title: 'Hola, ',
              text: 'En estos momentos, estamos trabajando en poner a disposición tu comprobante. Pero no te preocupes, en un plazo máximo de 5 días hábiles ya lo tendrás listo para la descarga.',
              confirmButtonText: 'Entendido'
            })
          } else {
            datosEventLog.Estado = 'Error'
            datosEventLog.error = res.data
            datosEventLog.statusCode = res.status
          }
          self.eventLog({
            categoria: 'Documentos',
            nombre: 'Consulta Comprobantes/Boletas',
            datos: datosEventLog
          })
        })
        .catch((err) => {
          datosEventLog.Estado = 'Error'
          datosEventLog.error = err.response.data
          datosEventLog.statusCode = err.response.status
          self.eventLog({
            categoria: 'Documentos',
            nombre: 'Consulta Comprobantes/Boletas',
            datos: datosEventLog
          })
        })
    }
  },
  computed: {
    ...mapGetters('user', ['functionsRules'])
  }
}
</script>

<style>
/** GLOBAL INFO */
.mediumSmall .box-global-info { border-bottom: #D8D8D8 12px solid; }
.mediumSmall .box-global-info ul { padding: 3px 0; }
.mediumSmall .box-global-info ul ol {
  overflow: hidden;
  padding-left: 0;
  border-bottom: 1px solid #D8D8D8;
  padding: 12px 22px;
}
.mediumSmall .box-global-info ul ol:last-child { border-bottom: 0; }
.mediumSmall .box-global-info ul ol p {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.mediumSmall .box-global-info ul ol p:first-child { float: left; }
.mediumSmall .box-global-info ul ol p:first-child + p { float: right; }
.mediumSmall .box-global-info ul ol p.poliza-download img {
  margin-right: 0;
  margin-left: 7px;
}
.mediumSmall .box-global-info ul ol p img {
  margin-right: 9px;
  width: 20px;
}
/** BENEFICIARIOS */
.mediumSmall .box-beneficiarios {
  border-bottom: #D8D8D8 12px solid;
  padding: 16px 0px;
  margin: 0;
}
.mediumSmall .box-beneficiarios .layout {
  margin-bottom: 0 !important;
  border-bottom: 1px solid #D8D8D8;
}
.mediumSmall .box-beneficiarios .layout { padding: 12px 22px; }
.mediumSmall .box-beneficiarios h2 {
  padding: 0 22px;
  margin-bottom: 0.4em !important;
}
.mediumSmall .box-beneficiarios .layout .percent-beneficiario p,
.mediumSmall .box-beneficiarios .layout .name-beneficiario p {
  margin-bottom: 0;
}
.mediumSmall .box-beneficiarios .layout .name-beneficiario p { text-transform: lowercase !important; }
.mediumSmall .box-beneficiarios .layout .name-beneficiario p::first-letter { text-transform: uppercase !important; }
.mediumSmall .box-beneficiarios .layout .percent-beneficiario p {
  text-align: right;
}
.mediumSmall .box-beneficiarios .layout:last-child { margin-bottom: 0.4em !important; }
/*
.mediumSmall .box-beneficiarios .layout .name-beneficiario {
  border: #D8D8D8 1px solid;
  padding: 7px 10px !important;
}
.mediumSmall .box-beneficiarios .layout .name-beneficiario p {
  margin-bottom: 0;
}
.mediumSmall .box-beneficiarios .layout .percent-beneficiario {
  border: #D8D8D8 1px solid;
  text-align: center;
  padding: 7px 10px !important;
}
.mediumSmall .box-beneficiarios .layout .percent-beneficiario p {
  margin-bottom: 0;
  color: #0855C4;
  font-weight: bold;
}
*/
/** AGENTE */
.mediumSmall .box-agente {
  border-bottom: #D8D8D8 12px solid;
  padding: 16px 22px;
}
.mediumSmall .box-agente .layout .flex {
  /* border: #D8D8D8 1px solid; */
  padding: 3px 2px !important;
}
.mediumSmall .box-agente .layout .flex p {
  margin-bottom: 0;
  display: block;
  font-weight: normal;
  font-family: 'Omnes Medium';
}
.mediumSmall .box-agente .layout .flex p img {
  width: 19px;
  margin-right: 12px;
  position: relative;
  top: 3px;
}
/** NUMERO DE POLIZA */
.mediumSmall .box-numero-poliza .layout .flex p {
  border: 1px solid #D8D8D8;
  padding: 0 24px;
  font-size: 16px;
  font-family: 'Omnes Medium';
  margin-bottom: 0;
  height: 41px;
  line-height: 44px;
}
/** MEDIO DE PAGO */
.mediumSmall .box-medio-pago h2 {
  color: #0855C4;
  font-weight: normal;
  font-size: 18px;
  margin-bottom: 0.5em;
}
.mediumSmall .box-medio-pago .layout .flex p {
  border: #D8D8D8 1px solid;
  padding: 0 24px;
  font-family: 'Omnes Medium';
  height: 42px;
  line-height: 42px;
}
/** ESTADO DE CUENTA */
/** COMPROBANTE ELECTRONICO */
.mediumSmall .box-comprobante-electronico {
  padding: 16px 22px;
}
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot {
  min-height: 46px;
  border: 1px solid #D8D8D8;
}
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot label { top: 14px; }
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections { padding-top: 3px; }
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections input::placeholder { color: rgba(0,0,0,0.87); }
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-select__selection { margin: 0; }
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-input__append-inner { margin-top: 12px; }
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon i {
  color: #0855C4;
  font-size: 30px;
}
/** GLOBAL STYLES */
.mediumSmall .flex .box-global-info h2 {
  padding: 0 22px;
  margin: 1em 0 0.4em 0;
}
.mediumSmall .box-global-info h2,
.mediumSmall .box-beneficiarios h2,
.mediumSmall .box-comprobante-electronico h2,
.mediumSmall .box-estado-cuenta h2,
.mediumSmall .box-numero-poliza h2,
.mediumSmall .box-agente h2,
.mediumSmall .box-beneficiarios h2 {
  display: flex;
  color: #0855C4;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 0.7em;
}
.mediumSmall .box-beneficiarios h2 img.question-mark-icon,
.mediumSmall .box-comprobante-electronico h2 img.question-mark-icon,
.mediumSmall .box-estado-cuenta h2 img.question-mark-icon,
.mediumSmall .box-numero-poliza h2 img.question-mark-icon,
.mediumSmall .box-agente h2 img.question-mark-icon,
.mediumSmall .box-beneficiarios h2 img.question-mark-icon,
.mediumSmall .box-global-info ul ol p:first-child img.question-mark-icon {
  margin-left: 8px;
}
.mediumSmall .box-numero-poliza,
.mediumSmall .box-medio-pago,
.mediumSmall .box-estado-cuenta {
  border-bottom: 12px solid #D8D8D8;
  margin-bottom: 0;
  padding: 16px 22px;
}
.mediumSmall .box-comprobante-electronico .layout,
.mediumSmall .box-estado-cuenta .layout {
  margin-top: 10px;
}
.mediumSmall .box-comprobante-electronico .flex p,
.mediumSmall .box-estado-cuenta .flex p {
  margin-bottom: 6px;
  font-size: 16px;
}
.mediumSmall .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot .v-input__prepend-inner,
.mediumSmall .box-estado-cuenta .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot .v-input__prepend-inner {
  padding-right: 6px;
  margin-top: 2px;
  align-self: center;
}
.mediumSmall .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot,
.mediumSmall .box-estado-cuenta .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot {
  min-height: 46px;
  border: 1px solid #D8D8D8;
}
.mediumSmall .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot .v-text-field__slot input,
.mediumSmall .box-estado-cuenta .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot .v-text-field__slot input {
  margin-top: 7px;
}
.v-btn.download-btn-files .v-btn__content,
#btnDownloadEstado .v-btn__content {
  font-family: 'Omnes Medium';
  color: #FFF;
}
/** MODAL DE COMPROBANTES */
#close-btn-ce {
  cursor: pointer;
  float: right;
}
.card-comprobantes h2 {
  text-align: center;
  clear: both;
  width: 95%;
  margin-top: 2.5em;
  margin-bottom: 1em;
}
.card-comprobantes .flex.comprobantes .layout {
  border: 2px solid #D8D8D8;
  border-radius: 4px;
}
.card-comprobantes .flex.comprobantes .layout .flex {
  text-align: center;
}
.card-comprobantes .flex.comprobantes .layout .flex p {
  margin-bottom: 0;
  margin: 10px 0;
  border-right: 1px solid #D8D8D8;
}
.card-comprobantes .flex.comprobantes .layout .flex img {
  border-bottom: 2px solid var(--fuchsia-color);
  padding-bottom: 3px;
  padding-top: 6px;
}
.card-comprobantes .flex.comprobantes .layout .flex:first-child + .flex {
  align-self: center;
}
p.message-date-alert-ce-mobile {
  font-size: 14px;
  text-align: center;
}
.v-btn.download-btn-files.btn-date-alert-ce-mobile {
  width: 100%;
  padding: 16px 0 17px 0;
  height: 50px;
  margin-bottom: 1em;
}
.v-btn.download-btn-files.btn-date-alert-ce-mobile .v-btn__content {
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/vida/FormMobileVida.vue